import axios from 'axios'
import Swal from 'sweetalert2'

const instance = axios.create({
    baseURL: 'https://rocky-thicket-05744.herokuapp.com'
  });

instance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    console.log(error, '>>>> ini dari axios interceptors')
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response.data.err.join(', ')
    })
    return Promise.reject(error);
  });
  

export default instance
